module.exports = __webpack_public_path__ + "img/logo.5c2445b0.svg";